/**
 * Ryan O'Dowd
 * 2022-08-03
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors, safeAreaInsets}) => {
  return {
    container: {
      flexGrow: 1,
    },
    list: {
      flexGrow: 1,
      paddingBottom: safeAreaInsets.bottom + 4,
      paddingTop: 16,
    },
    innerContainer: {
      flexGrow: 1,
    },
    messageWrapper: {
      marginRight: 8,
      marginLeft: 8,
    },
    joinMessage: {
      fontSize: globalScale * 14,
      color: colors.accentLight,
    },
    errorText: {
      color: colors.complete,
    },
    descriptionWrapper: {
      marginRight: 16,
      marginLeft: 16,
    },
    descriptionText: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      marginBottom: 16,
      fontSize: globalScale * 16,
      color: colors.white,
    },
    organizationInfoWrapper: {
      marginRight: 16,
      marginLeft: 16,
      marginBottom: 32,
    },
    link: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      fontSize: globalScale * 16,
      color: colors.accent,
    },
    formSection: {
      paddingTop: 0,
      paddingRight: 16,
      paddingBottom: 4,
      paddingLeft: 16,
    },
    formSectionInner: {
      paddingTop: 4,
      paddingRight: 16,
      paddingBottom: 16,
      paddingLeft: 16,
    },
    joinWrapper: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: 0,
      margin: 0,
    },
    textInputWrapper: {
      flex: 1,
      maxWidth: 250,
      marginRight: globalScale * 8,
    },
    titleTextInput: {
      display: 'flex',
      padding: 0,
      margin: 0,
    },
    campaigns: {
      marginTop: 8,
    },
    sectionHeaderText: {
      color: colors.white,
      fontSize: globalScale * 18,
      fontFamily: fonts.primaryBold,
    },
  };
};

export default getStyles;
